import { useEffect, useState } from 'react';
import { Api } from '../api';



export const useCategoriesList: () => [Record<string, any>[], boolean] = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        Api.categories.list().then((res) => {
            setData(res.data);
        }).catch(err => {
            console.error(err);
        }).finally(() => {
            setLoading(false);
        })
    }, []);

    return [data, loading];
}